module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/marquette-university-933cd3a298081649bb74bf536fcd07bf.jpg";